export default "__VITE_ASSET__BKAPl8$u__"